import en from "./en.js";
import ru from "./ru.js";
import it from "./ita.js";

let lang = localStorage.getItem("language")
  ? localStorage.getItem("language")
  : "ru";

export const locale = {
  locale: lang,
  fallback: "ru",
  globalInjection: true,
  messages: { en, ru, it },
};
